<template>
	<bernstein-layout>
		<!-- test -->
		<!-- {{ params }} -->
		<!-- {{ orderitems.data[0].variation.item.name1 }} -->
		<!-- <div v-for="orderitem in orderitems">{{ orderitem.plenty_id }}</div> -->
		<div class="flex flex-row justify-between py-2">
			<Link
				v-if="orderitems.prev_page_url"
				class="m-2 rounded bg-gray-300 px-4 py-2 font-bold"
				:href="orderitems.prev_page_url"
				>Previous Page
			</Link>
			<div class="px-2 py-2 text-lg font-bold text-gray-800">Order Items</div>
			<Link
				v-if="orderitems.next_page_url"
				class="m-2 rounded bg-gray-300 px-4 py-2 font-bold"
				:href="orderitems.next_page_url"
				>Next Page
			</Link>
		</div>

		<Table
			:filters="queryBuilderProps.filters"
			:search="queryBuilderProps.search"
			:columns="queryBuilderProps.columns"
			:on-update="setQueryBuilder"
			:meta="orderitems"
			class="relative w-full border"
		>
			<!-- Table head  -->
			<template #head>
				<tr
					class="sticky border-b border-gray-400 bg-gray-300 py-2 font-bold text-gray-900"
				>
					<!-- <th @click.prevent="sortBy('name')">Stock Id</th> -->
					<!-- <td v-show="showColumn('manufacturerId')">S.N.</td> -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('orderId')"
						@click.prevent="sortBy('order_items.orderId')"
					>
						<span class="flex flex-row space-x-2">
							<span> Order Id</span>
							<svg
								v-if="params.sort == 'order_items.orderId'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-order_items.orderId'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>
					<!-- externalId -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('externalId')"
						@click.prevent="sortBy('externalId')"
					>
						<!-- External Id for up and down  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2">External Id</span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'externalId'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-externalId'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>

					<!-- Variation id -->
					<!-- @click.prevent="sortBy('itemVariationId')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('itemVariationId')"
					>
						Variation Id
					</th>
					<!-- type id -->
					<!-- @click.prevent="sortBy('typeId')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('typeId')"
						@click.prevent="sortBy('orders.typeId')"
					>
						<!-- Status Id for up and down  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2">Type Id</span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'typeId'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-typeId'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>

					<!-- Order item name   -->
					<!-- @click.prevent="sortBy('orderItemName')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('itemName')"
					>
						OrderItem Name
					</th>
					<!-- Updated At  -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('updatedAt')"
						@click.prevent="sortBy('order_items.updatedAt')"
					>
						<span class="flex flex-row space-x-2">
							<span class="px-2">Updated At </span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'order_items.updatedAt'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-order_items.updatedAt'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>
					<!-- Quantity  -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('quantity')"
						@click.prevent="sortBy('quantity')"
					>
						<!-- Quantity aroow for sorting  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2">Quantity </span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'quantity'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-quantity'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>
					<!-- Status name   -->
					<!-- @click.prevent="sortBy('statusId')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('statusId')"
					>
						<!-- Status Id for up and down  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2">Status Id </span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'statusId'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-statusId'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>

					<!-- Status name   -->
					<!-- @click.prevent="sortBy('statusName')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('statusName')"
					>
						Status Name
					</th>

					<!--  Image  -->
					<!-- @click.prevent="sortBy('statusName')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('urlPreview')"
					>
						Image
					</th>

					<!-- billNo -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('billNo')"
						@click.prevent="sortBy('billNo')"
					>
						<!-- Bill No arrow for up and down  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2">Bill No </span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'billNo'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-billNo'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>

					<!-- paymentType -->
					<!-- @click.prevent="sortBy('order.paymentType')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('paymentType')"
					>
						Payment Type
					</th>
					<!-- Purchase price -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('purchasePrice')"
						@click.prevent="sortBy('purchasePrice')"
					>
						<!-- 	Gross Total aroow for sorting  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2"> Purchase Price </span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'purchasePrice'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-purchasePrice'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>
					<!-- grossTotal -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('priceGross')"
						@click.prevent="sortBy('priceGross')"
					>
						<!-- 	Gross Total aroow for sorting  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2"> price Gross </span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'priceGross'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-priceGross'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>
					<!-- deleveryCountry -->
					<!-- @click.prevent="sortBy('order.deleveryCountry')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('deleveryCountry')"
					>
						Delevery Country
					</th>
					<!-- return reasons -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('return_reason')"
					>
						Return Reason
					</th>
				</tr>
				<!-- <tr><th class="fixed top-0"> test</th> </tr>      -->
			</template>
			<!--
       ******
       * 
       * here starts the table body  
       *
       -->
			<template #body>
				<tr
					v-for="(orderitem, orderIndx) in orderitems.data"
					:key="orderIndx"
					:class="[{ 'bg-gray-100': orderIndx % 2 == 0 }, p - 1]"
				>
					<td class="border-r border-green-200" v-show="showColumn('orderId')">
						{{ orderitem.orderId }}
					</td>
					<!-- externalId -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('externalId')"
					>
						{{ orderitem.externalId }}
					</td>
					<!-- itemVariationId  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('itemVariationId')"
					>
						{{ orderitem.itemVariationId }}
					</td>
					<!-- type id -->
					<td class="border-r border-green-200" v-show="showColumn('typeId')">
						{{ orderitem.typeId }}
					</td>
					<!-- order item name  -->
					<td class="border-r border-green-200" v-show="showColumn('itemName')">
						{{ orderitem.variation.item.name1 }}
					</td>

					<!-- udpated at  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('updatedAt')"
					>
						{{ orderitem.updatedAt }}
					</td>
					<!-- Quantity -->
					<td class="border-r border-green-200" v-show="showColumn('quantity')">
						{{ orderitem.quantity }}
					</td>
					<!-- status id  -->
					<td class="border-r border-green-200" v-show="showColumn('statusId')">
						{{ orderitem.statusId }}
					</td>
					<!-- status name  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('statusName')"
					>
						{{ orderitem.statusName }}
					</td>
					<!-- image1_urlPreview  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('urlPreview')"
					>
						<!-- {{ orderitem.image1_urlPreview }} -->
						<!-- @click="openModal(stock.image1_urlPreview)" -->
						<img
							v-if="orderitem.urlPreview"
							:src="orderitem.urlPreview"
							class="max-w-16 max-h-16 object-fill"
						/>
					</td>

					<!-- billNo  -->
					<td class="border-r border-green-200" v-show="showColumn('billNo')">
						{{ orderitem.billNo }}
					</td>

					<!-- paymentType -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('paymentType')"
					>
						{{ orderitem.paymentType }}
					</td>
					<!-- purchasePrice -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('purchasePrice')"
					>
						{{ orderitem.purchasePrice.toFixed(2) }}
					</td>

					<!-- grossTotal -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('priceGross')"
					>
						{{ orderitem.priceGross.toFixed(2) }}
					</td>
					<!-- deleveryCountry -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('deleveryCountry')"
					>
						{{ orderitem.deleveryCountry }}
					</td>
					<!-- return reason  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('return_reason')"
					>
						{{ orderitem.return_reason }}
					</td>
				</tr>
			</template>
			<!-- Table head ends here  -->
		</Table>
	</bernstein-layout>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import {
	InteractsWithQueryBuilder,
	Tailwind2,
} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogOverlay,
	DialogTitle,
} from "@headlessui/vue";
import { defineComponent, ref } from "vue";
// import Counter from "./Counter.vue";
export default defineComponent({
	mixins: [InteractsWithQueryBuilder],
	components: {
		BernsteinLayout,
		Head,
		Link,
		Table: Tailwind2.Table,
		// Modal components
		TransitionRoot,
		TransitionChild,
		Dialog,
		DialogOverlay,
		DialogTitle,
	},
	props: {
		params: Array,
		orderitems: Array,
	},
	setup() {
		name = ref("test");
		// const name = ref<string>("Bijaya");
		return {
			name,
			getName() {
				console.log("test");
			},
		};
	},
});
</script>
